import { render, staticRenderFns } from "./CptuList.vue?vue&type=template&id=2d185654&scoped=true"
import script from "./CptuList.vue?vue&type=script&lang=js"
export * from "./CptuList.vue?vue&type=script&lang=js"
import style0 from "./CptuList.vue?vue&type=style&index=0&id=2d185654&prod&lang=scss&scoped=true"
import style1 from "./CptuList.vue?vue&type=style&index=1&id=2d185654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d185654",
  null
  
)

export default component.exports